import { render, staticRenderFns } from "./SingleSpreadView.vue?vue&type=template&id=a2ee9966"
import script from "./SingleSpreadView.vue?vue&type=script&lang=js"
export * from "./SingleSpreadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2ee9966')) {
      api.createRecord('a2ee9966', component.options)
    } else {
      api.reload('a2ee9966', component.options)
    }
    module.hot.accept("./SingleSpreadView.vue?vue&type=template&id=a2ee9966", function () {
      api.rerender('a2ee9966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/views-page/SingleSpreadView.vue"
export default component.exports